module.exports = __webpack_public_path__ + "static/media/dislike.0e485fbb.svg";